




























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CollapsibleSection extends Vue {
	@Prop() public index: any;
	@Prop() public value: any;

	public isActive() {
		return this.index === this.value;
	}

	public setActive() {
		this.$emit('input', this.index);
	}
}

